import "./HelpCenter.css";

import { HelpCenterChevronRightIcon, HelpCenterCloseIcon, HelpCenterExternalLinkIcon } from "../../../assets";
import { HELP_CENTER_CONTACT_SUPPORT_URL, HELP_CENTER_TOPICS, HELP_CENTER_URL } from "./constants/helpCenter";
import { HelpCenterVariant } from "./models/HelpCenterVariant";

interface HelpCenterProps {
  show: boolean;
  variant?: HelpCenterVariant;
  onClose: () => void;
}

export const HelpCenter = ({ show, variant = "default", onClose }: HelpCenterProps): JSX.Element | undefined => {
  if (!show) {
    return undefined;
  }

  const topics =
    variant === "hub" ? HELP_CENTER_TOPICS.filter((topic) => topic.slug !== "pipeline-deals") : HELP_CENTER_TOPICS;

  return (
    <div className={`HelpCenter ${variant}`}>
      <div className="HelpCenterHeader">
        <span className="HelpCenterTitle">Help Centre</span>
        <button type="button" className="HelpCenterCloseButton" onClick={onClose} aria-label="Close help centre">
          <HelpCenterCloseIcon />
        </button>
      </div>
      <div className="HelpCenterBody">
        <span className="HelpCenterSectionLabel">Topics</span>
        <nav className="HelpCenterTopics" aria-label="Help topics">
          {topics.map((topic) => (
            <a key={topic.slug} className="HelpCenterTopic" href={topic.href} target="_blank" rel="noopener noreferrer">
              <span className="HelpCenterTopicIcon" aria-hidden="true">
                {topic.icon}
              </span>
              <span className="HelpCenterTopicText">
                <span className="HelpCenterTopicTitle">{topic.title}</span>
                <span className="HelpCenterTopicSubtitle">{topic.subtitle}</span>
              </span>
              <span className="HelpCenterTopicChevron" aria-hidden="true">
                <HelpCenterChevronRightIcon />
              </span>
            </a>
          ))}
        </nav>
      </div>
      <div className="HelpCenterFooter">
        <a className="HelpCenterVisitLink" href={HELP_CENTER_URL} target="_blank" rel="noopener noreferrer">
          <HelpCenterExternalLinkIcon />
          <span>Visit full help centre</span>
        </a>
        <a
          className="HelpCenterSupportLink"
          href={HELP_CENTER_CONTACT_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact support
        </a>
      </div>
    </div>
  );
};
